import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_006.jpg';
page.paint = [
  {
    id: 'page003_game3',
    icon: 'ikona_cw3',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Pokoloruj rysunek dziecka.  ',
      audio: 'files/page003/z3c3.mp3',

      item: {
        path: 'informatyka/files/page003/z.3cw.3.bmp',
      },
      cssStyle: {
        width: '765px !important',
        height: 'auto',
      },
    },
    pos: {
      x: LEFT,
      y: 400,
    },
  },
];
page.games = [
  {
    id: 'page003_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  {
    id: 'page003_game2',
    tooltip: '',
    icon: 'ikona_cw2',
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page003_game4',
    tooltip: '',
    icon: 'ikona_cw4',
    pos: {
      x: LEFT,
      y: 600,
    },
  },
];
page.images = [
  {
    imageId: 'page006_zoom0',
    rectangle: {
      x: 136,
      y: 1655,
      width: 1634,
      height: 630,
    },
    imageSrc: 'images/page006/006 7.jpg',
  },
  {
    imageId: 'page006_zoom1',
    rectangle: {
      x: 1260,
      y: 902,
      width: 516,
      height: 500,
    },
    imageSrc: 'images/page006/006 6.jpg',
  },
  {
    imageId: 'page006_zoom2',
    rectangle: {
      x: 700,
      y: 900,
      width: 522,
      height: 500,
    },
    imageSrc: 'images/page006/006 5.jpg',
  },
  {
    imageId: 'page006_zoom3',
    rectangle: {
      x: 144,
      y: 902,
      width: 522,
      height: 498,
    },
    imageSrc: 'images/page006/006 4.jpg',
  },
  {
    imageId: 'page006_zoom4',
    rectangle: {
      x: 1260,
      y: 368,
      width: 520,
      height: 500,
    },
    imageSrc: 'images/page006/006 3.jpg',
  },
  {
    imageId: 'page006_zoom5',
    rectangle: {
      x: 700,
      y: 368,
      width: 517,
      height: 495,
    },
    imageSrc: 'images/page006/006 2.jpg',
  },
  {
    imageId: 'page006_zoom6',
    rectangle: {
      x: 140,
      y: 366,
      width: 521,
      height: 497,
    },
    imageSrc: 'images/page006/006 1.jpg',
  },
];
// page.games = [
//   {
//     id: 'page035_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 0,
//     },
//   },
//   {
//     id: 'page035_game11',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 100,
//     },
//   },
//   {
//     id: 'page035_game12',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 200,
//     },
//   },
//   {
//     id: 'page037_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 300,
//     },
//   },
//   {
//     id: 'page037_game11',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 400,
//     },
//   },
//   {
//     id: 'page037_game12',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 500,
//     },
//   },
//   {
//     id: 'page039_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 600,
//     },
//   },
//   {
//     id: 'page039_game11',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 700,
//     },
//   },
//   {
//     id: 'page040_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 800,
//     },
//   },
//   {
//     id: 'page042_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 900,
//     },
//   },
//   {
//     id: 'page043_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 1000,
//     },
//   },
//   {
//     id: 'page045_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 1100,
//     },
//   },
//   {
//     id: 'page045_game11',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 1200,
//     },
//   },
//   {
//     id: 'page050_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 1300,
//     },
//   },
//   {
//     id: 'page051_game10',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 1400,
//     },
//   },
//   {
//     id: 'page051_game11',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 1500,
//     },
//   },
//   {
//     id: 'page051_game12',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 1600,
//     },
//   },
// ];
export default page;
